var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M19.73 18.41L15.94 14.62C16.74 13.57 17.22 12.26 17.22 10.85C17.22 7.39997 14.41 4.58997 10.96 4.58997C7.50995 4.58997 4.69995 7.39997 4.69995 10.85C4.69995 14.3 7.50995 17.11 10.96 17.11C12.27 17.11 13.49 16.7 14.5 16.01L18.32 19.83L19.73 18.42V18.41ZM6.68995 10.85C6.68995 8.49997 8.59995 6.58997 10.95 6.58997C13.3 6.58997 15.21 8.49997 15.21 10.85C15.21 12.02 14.74 13.08 13.97 13.85L13.95 13.87C13.18 14.64 12.12 15.11 10.95 15.11C8.59995 15.11 6.68995 13.2 6.68995 10.85Z",
    fill: "#727272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1a5b3d9a08e7969464e6aa485c2522c2.svg";
export { ForwardRef as ReactComponent };